import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/callout.10de9efe.svg'


const _withScopeId = n => (_pushScopeId("data-v-391a3588"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "editEntry" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"267px","height":"220px"},
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "随心写作，自由表达", -1))
const _hoisted_4 = { class: "columnList" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "发现精彩", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ColumnList = _resolveComponent("ColumnList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, {
          to: "/create",
          type: "button",
          class: "btn btn-primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("开始写文章")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_ColumnList, { list: _ctx.list }, null, 8, ["list"]),
      (!_ctx.isLastPage)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "addMore btn btn-outline-primary mt-2 mb-5 btn-block w-25",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadMorePage && _ctx.loadMorePage(...args)))
          }, " 加载更多 "))
        : _createCommentVNode("", true)
    ])
  ], 64))
}